module.exports = __webpack_public_path__ + "static/img/5.2a69f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/5.jpg
// module id = zkcX
// module chunks = 1